import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSOutbondURL = process.env.REACT_APP_API_WMSOUTBOUND_URL;
const baseUrl = `${WMSOutbondURL}order-details`;
export const OrderDetailsService = {
    getAll,
    getById,
    create,
    getByOrderId,
    update,
    UpdateOrderOutboundStatus,
    orderReAllocation,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getByOrderId(id) {
    return fetchWrapper.get(`${baseUrl}?orderId=${id}`);
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function UpdateOrderOutboundStatus(params) {
    return fetchWrapper.post(`${baseUrl}/orderOutBound`, params);
}
function orderReAllocation(params) {
    return fetchWrapper.post(`${baseUrl}/orderReAllocation`, params);
}
function updateFormData(params, id) {
    return fetchWrapper.put(`${baseUrl}/upload/create-master/${id}`, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}